import { fileToDataUrl } from './file-to-data-url';

export async function fileToDataUrlWithName(file: File): Promise<string> {
  const dataUrl = await fileToDataUrl(file);
  return `${file.name};${dataUrl}`;
}
